module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('strong', [_c('em', [_vm._v("Contents")])])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Series Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Authorspreface#fm-2"
    }
  }, [_c('em', [_vm._v("Author’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-3"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Selectbibliography#fm-4"
    }
  }, [_c('em', [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Introduction#fm-5"
    }
  }, [_vm._v("GENERAL INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Part01#pt-1"
    }
  }, [_c('strong', [_vm._v("THE LETTER OF JUDE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("INTRODUCTION TO JUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-1"
    }
  }, [_vm._v("I. Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-2"
    }
  }, [_vm._v("II. Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-3"
    }
  }, [_vm._v("III. Place and Date")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.65em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-4"
    }
  }, [_vm._v("IV. Addressees")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-5"
    }
  }, [_vm._v("V. Language and Structure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-6"
    }
  }, [_vm._v("VI. Theology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON JUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Letter Opening: Salutation (vv. 1-2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Letter Body (vv. 3-23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Body Opening: Thematic Statement "), _c('em', [_vm._v("(exordium/narratio)")]), _vm._v(" (vv. 3-4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Body Proper: Proof for the Thematic Statement (vv. 5-16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. First Proof (vv. 5-7 and 8-10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Second Proof (vv. 11-13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("3. Third Proof (vv. 14-16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Body Closing (vv. 17-23)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Final Prophecy (vv. 17-19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Closing Exhortation (vv. 20-23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Letter Closing: Doxology (vv. 24-25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("THE LETTER OF 2 PETER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION TO 2 PETER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Authorship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Date, Language, and Style")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.65em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Recipients and Opponents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. Jude and 2 Peter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. Literary Form")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. Theology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. The Holy Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. The Human Condition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. Deliverance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. Eschatology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter03#sec2-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY ON 2 PETER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "1.2em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Salutation (1:1-2)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.9em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Letter Opening (1:3-15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. Opening Sermon (1:3-11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Historical Introduction: The Divine Benefaction (1:3-4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Call to Virtue (1:5-11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Purpose Statement (1:12-15)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. Letter Body (1:16–3:16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. The Implications of the Transfiguration (1:16-21)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. Condemnation of the False Teachers (2:1-22)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("1. Introduction to the False Teachers (2:1-3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("2. Argument for the Judgment of the False Teachers (2:4-22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Excursus on Balaam in Rabbinic Literature")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter04#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. Conclusions about the Day of the Lord (3:1-13)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter04#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. Body Closing: Final Judgment (3:14-16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    staticStyle: {
      "padding-left": "0.65em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter04#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. Letter Closing (3:17-18)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-064c758a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0